export default __webpack_public_path__ + "static/1.2_EN-d57c79123cbaee5f0902675d349c9603.webp";